/* eslint-disable react/jsx-key */
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';
import { Button, Pagination } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';
import { round } from 'mathjs';
import posthog from 'posthog-js';

import Color from '@tool/color';
import {
  CloseIcon20, ArrowDown, HouseIcon,
  CollectionIcon, CollectionFillIcon,
  UpChangeIcon, DownChangeIcon,
} from '@styled/icon';
import { locateValue } from '@tool/index';
import moDashboard, {
  changeTime, changeCollectType,
} from '../../store';
import moSalary, {
  onCollectPosition, unCollectPosition, onJob,
  requestPositionList, positionListPage,
  hoverPositionAmount, leavePositionAmount,
  hoverPositionSalary, leavePositionSalary,
  onMultiJob,
} from '../store/salary';
import moUser from '@store/user';
import {
  HtmlTooltip, DMenuItem, DIconButton, DStack,
  DSelect, LookButton,
} from './styled';
import Empty from '@comp/empty';

interface IProps {}
interface IState {}

const PositionList = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { activeTab, activeTime, collectType } = moDashboard;
  const {
    positionRecent, positionList, positionListAll,
    positionCurrentPage, positionPageCount,
  } = moSalary;
  const { isVip, isMarketExpired, industry, city, scale, nature } = moUser;

  useEffect(() => {
    return () => {};
  }, []);

  const changeMonth = (ev: any) => {
    requestPositionList(ev.target.value);
  };

  const chooseJob = (item: any) => {
    posthog.capture('查看职位详细报告人数', {});
    onJob(item);
  };

  const calcDistance = (fix25: number, fix50: number, fix75: number) => {
    return round((fix50 - fix25) / (fix75 - fix25) * 100, 1);
  };

  // 第二个参数 - 保留几位小数
  const newRate = (value: any, digit: number = 1) => {
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(value)) return '-';
    if (value === null || value === '' || value === undefined) return '-';
    if (value === 0) return 0;
    const newValue = round(value * 100, digit);
    if (newValue === 0) return 0;
    return `${newValue}%`;
  };

  return (
    <section className="section-1155">
      <section className="line-101">
        <>
          <span>热门职位列表 <b className="mont-font">{positionListAll.length}</b></span>
          {(!isMarketExpired && !isEmpty(positionList)) ? (
            <LookButton variant="contained" color="primary"
              onClick={() => onMultiJob(positionList)}>批量查看薪酬报告</LookButton>
          ) : null}
        </>
      </section>

      {!isEmpty(positionList) ? (
        <>
          <section className="line-103">
            <p className="line-10301">
              <span>年固定薪酬的市场范围：</span>
              {isMarketExpired ? (
                <span>
                  <HouseIcon color={Color.d9} />
                  <b>全行业</b>&nbsp;|&nbsp;<b>全国</b>&nbsp;|&nbsp;不限&nbsp;|&nbsp;不限
                </span>
              ) : (
                <span>
                  <HouseIcon color={Color.d9} />
                  <b>{industry.name || '全行业'}</b>&nbsp;|&nbsp;
                  <b>{city.name || '全国'}</b>&nbsp;|&nbsp;
                  <b>{scale.name || '不限'}</b>&nbsp;|&nbsp;
                  <b>{nature.name || '不限'}</b>
                </span>
              )}
            </p>
            <section className="line-10301">
              <span>变化率时间：</span>
              <DSelect value={positionRecent}
                onChange={(event: any) => changeMonth(event)}>
                <DMenuItem value="近3个月">近3个月</DMenuItem>
                <DMenuItem value="近6个月">近6个月</DMenuItem>
                <DMenuItem value="近12个月">近12个月</DMenuItem>
              </DSelect>
            </section>
          </section>

          <section className="section-199">
            <section className="header-199">
              <p className="line-001">职位名称</p>
              <p className="line-001">
                <span className="span-111">年固定薪酬</span>
                <span>
                  <i className="i-111">25分位</i>
                  <i className="i-111">50分位</i>
                  <i>75分位</i>
                </span>
              </p>
              <p className="line-001">
                <span className="span-111">{positionRecent}</span>
                <span>
                  <i className="i-111">薪酬变化率</i>
                  <i className="i-111">招聘量变化率</i>
                  <i>招聘热度</i>
                </span>
              </p>
              <p className="line-003">操作</p>
            </section>

            {positionList.map((item: any, index: number) => (
              <section key={index} className="line-199">
                <section onClick={() => chooseJob(item)}
                  className="line-200">
                  <section className="line-2001">
                    <section className="line-20011">
                      <strong>{item.name}</strong>
                      {item.amount_label ? (
                        <>
                          {item.salary_label ? (
                            <>
                              {item.salaryHover ? (
                                <b onMouseEnter={() => hoverPositionAmount(item)}
                                  onMouseLeave={() => leavePositionAmount(item)}
                                  className={[
                                    'b-02', item.amount_change > 0 ? 'up' : 'down',
                                  ].join(' ')}>···</b>
                              ) : (
                                <b onMouseEnter={() => hoverPositionAmount(item)}
                                  onMouseLeave={() => leavePositionAmount(item)}
                                  className={[
                                    'b-02', item.amount_change > 0 ? 'up' : 'down',
                                  ].join(' ')}>{item.amount_label}
                                </b>
                              )}
                            </>
                          ) : (
                            <b className={[
                              'b-02', item.amount_change > 0 ? 'up' : 'down',
                            ].join(' ')}>{item.amount_label}
                            </b>
                          )}
                        </>
                      ) : null}
                      {item.salary_label ? (
                        <>
                          {item.amount_label ? (
                            <>
                              {item.amountHover ? (
                                <b onMouseEnter={() => hoverPositionSalary(item)}
                                  onMouseLeave={() => leavePositionSalary(item)}
                                  className={[
                                    'b-02', item.salary_change > 0 ? 'up' : 'down',
                                  ].join(' ')}>···</b>
                              ) : (
                                <b onMouseEnter={() => hoverPositionSalary(item)}
                                  onMouseLeave={() => leavePositionSalary(item)}
                                  className={[
                                    'b-02', item.salary_change > 0 ? 'up' : 'down',
                                  ].join(' ')}>{item.salary_label}</b>
                              )}
                            </>
                          ) : (
                            <>
                              <b className={[
                                'b-02', item.salary_change > 0 ? 'up' : 'down',
                              ].join(' ')}>{item.salary_label}</b>
                            </>
                          )}
                        </>
                      ) : null}
                    </section>
                    <p className="line-20013">
                      <b className="b-01">{item.rank}</b>
                      <span className="text-00">{item.category_lv1} - {item.category_lv2} - {item.category_lv3}</span>
                    </p>
                  </section>
                </section>

                {item.fix_75 ? (
                  <section onClick={() => chooseJob(item)}
                    className="line-200">
                    <section className="line-2002">
                      <b className="mont-font b-00">{round(item.fix_25 / 10000, 0)}万</b>
                      <section className="line-20021">
                        <i style={{ left: `${calcDistance(item.fix_25, item.fix_50, item.fix_75)}%` }} />
                        <b className="mont-font"
                          style={{ left: `${calcDistance(item.fix_25, item.fix_50, item.fix_75)}%` }}>
                          {round(item.fix_50 / 10000, 1)}万
                        </b>
                        <span />
                      </section>
                      <b className="mont-font b-00">{round(item.fix_75 / 10000, 0)}万</b>
                    </section>
                  </section>
                ) : (
                  <section className="line-200">
                    <p className="line-200255">
                      <b>N / A</b>
                      <span>该职位在所选行业下，暂无数据</span>
                    </p>
                  </section>
                )}

                <section onClick={() => chooseJob(item)}
                  className="line-200">
                  <section className="line-2003">
                    <section className="p-00">
                      {(item.salary_change > 0 && newRate(Math.abs(item.salary_change)) !== 0) ? <UpChangeIcon /> : null}
                      {(item.salary_change < 0 && newRate(Math.abs(item.salary_change)) !== 0) ? <DownChangeIcon /> : null}
                      <b className="mont-font">{newRate(Math.abs(item.salary_change))}</b>
                    </section>
                    <section className="p-00">
                      {(item.amount_change > 0 && newRate(Math.abs(item.amount_change)) !== 0) ? <UpChangeIcon /> : null}
                      {(item.amount_change < 0 && newRate(Math.abs(item.amount_change)) !== 0) ? <DownChangeIcon /> : null}
                      <b className="mont-font">{newRate(Math.abs(item.amount_change))}</b>
                    </section>
                    <section className="p-00 p-01">
                      <p className="line-20025">
                        <i style={{ left: `${item.heat}%` }} />
                        <b className="mont-font"
                          style={{ left: `${item.heat}%` }}>{item.heat}</b>
                        <span />
                      </p>
                    </section>
                  </section>
                </section>

                <p className="line-201">
                  {item.is_collected ? (
                    <DIconButton onClick={() => unCollectPosition(item)}>
                      <CollectionFillIcon width={16} height={16} color={Color.secondary} />
                    </DIconButton>
                  ) : (
                    <DIconButton onClick={() => onCollectPosition(item)}>
                      <CollectionIcon width={16} height={16} color={Color.c999} />
                    </DIconButton>
                  )}
                </p>
              </section>
            ))}

          </section>

          <DStack spacing={2}>
            <Pagination count={positionPageCount} page={positionCurrentPage}
              color="primary" variant="outlined" shape="rounded"
              onChange={(ev: any, page: number) => positionListPage(page)} />
          </DStack>
        </>
      ) : <Empty padding="50px 0" />}

    </section>
  );
};

export default observer(PositionList);
